<div class="d-flex align-items-center justify-content-center" [ngSwitch]="data.status">
    <span *ngSwitchCase="1" class="badge-success caption custom-budge d-flex align-items-center justify-content-center">Live</span>
    <span *ngSwitchCase="2" class="badge-warning caption custom-budge d-flex align-items-center justify-content-center">Pending</span>
    <span *ngSwitchCase="3" class="badge-danger caption custom-budge d-flex align-items-center justify-content-center">Deleted</span>
    <span *ngSwitchDefault class="badge-dark caption custom-budge d-flex align-items-center justify-content-center">Unknown</span>
</div>

